export default "__VITE_ASSET__7668984a__"